import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import TableCM from "components/shared/Table";
import DrawerCM from "components/shared/Drawer";
import GenarateHeadCell from "helper/generate-head-cell";
import PaginationCM from "components/shared/Pagination";
import { getProductsRequest } from "api/requests";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import { Link } from "react-router-dom";
import { PAGINATION_LIMIT } from "constants";
import { FaImages } from "react-icons/fa";
import { GoPaintcan } from "react-icons/go";
import { FaCheck, FaTimes } from "react-icons/fa";

const headCells = GenarateHeadCell("products");
let initialPage = 1;

export default function Products() {
  const navigate = useNavigate();
  const [products, setProducts] = useState({ data: [], count: 0 });
  const { request, loading } = useHttp();
  const [page, setPage] = useState(initialPage);

  const handelSearch = (e) => getProducts(e);

  /////////////get Products/////////////
  const getProducts = useCallback(
    async (search) => {
      const res = await request({
        url: getProductsRequest,
        values: {
          skip: search ? 0 : (page - 1) * PAGINATION_LIMIT,
          limit: search ? 100 : PAGINATION_LIMIT,
          search,
        },
      });

      if (res.count < 1) {
        return setProducts({
          count: res.count,
          data: [{ content: "هیچ محصولی یافت نشد" }],
        });
      }
      if (res) {
        let transformedData = res.data.map((items) => ({
          id: items.id,
          title: items.title,
          type: items.design?.category?.type,
          category: items.design?.category?.title,
          design: items.design?.title,
          price: items.price,
          amazing:
            items.amazing_offer == true ? (
              <FaCheck color="green" />
            ) : (
              <FaTimes color="red" />
            ),
          edit: (
            <Link to={`/products/${items.id}`}>
              <IconButton color="primary">
                <EditIcon />
              </IconButton>
            </Link>
          ),
          color: (
            <Link to={`/color/${items.id}`}>
              <IconButton color="primary">
                <GoPaintcan />
              </IconButton>
            </Link>
          ),
        }));
        setProducts({ data: transformedData, count: res.count });
      }
    },
    [page, request]
  );

  useEffect(() => {
    getProducts();
  }, [page, getProducts]);

  return (
    <DrawerCM title="محصولات" onSearch={handelSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2} spacing={1}>
          <Grid item xs={12} my={2}>
            <TableCM
              title="لیست محصولات"
              rows={products.data}
              headCells={headCells}
              addProduct
              page={page}
            />
          </Grid>
          <PaginationCM
            handleChange={(e, val) => {
              initialPage = val;
              setPage(val);
            }}
            page={page}
            count={products.count}
          />
        </Grid>
      )}
    </DrawerCM>
  );
}
